// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__2TMH6","links":"footer_links__CZt3i","logo":"footer_logo__sqi1-","box":"footer_box__1hs0c","copywrite":"footer_copywrite__kZuQo"};